import type { ControlCardEquipment } from '../infrastructure'
import type { GenerateControlCardRequest } from './dtos/ControlCardDTOs'

/** The inspection's order number wins over the one stored on the equipment. */
export function withOrderNumber(
  equipment: ControlCardEquipment,
  request: GenerateControlCardRequest
): ControlCardEquipment {
  const orderNo = request.inspection.orderNo?.trim()
  return orderNo ? { ...equipment, serviceOrder: orderNo } : equipment
}
